import React, {useState} from 'react';
import {Switch} from 'react-router-dom';
import {VersionReloadRoute} from '../../containers/version_reload_route';
import {SecondaryNavStateProvider} from '../navigation/secondary/SecondaryNavigationStateManager';
import ClientSecondaryNavigation from './ClientSecondaryNavigation';
import CompanyViewPage from './CompanyViewPage';

type Props = {
	clientId: string;
};

// Route-level shell for the client/company view: a persistent secondary navigation alongside a
// content area that swaps between client sub-sections. Mirrors ProjectRoutes. Today the only
// section is the Overview; future sections are added as additional routes inside the Switch.
const CompanyViewRoutes: React.FC<Props> = ({clientId}) => {
	const [currentPath, updateCurrentPath] = useState(window.location.pathname + window.location.hash);

	return (
		<SecondaryNavStateProvider>
			<div style={{flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'row'}}>
				<ClientSecondaryNavigation
					clientId={clientId}
					currentPath={currentPath}
					updateCurrentPath={updateCurrentPath}
				/>
				<div style={{flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto'}}>
					<Switch>
						<VersionReloadRoute
							exact
							path="/clients/:clientId"
							children={({match}) => {
								const id = match.params.clientId;
								if (!id) return null;
								return <CompanyViewPage clientId={id} />;
							}}
						/>
					</Switch>
				</div>
			</div>
		</SecondaryNavStateProvider>
	);
};

export default CompanyViewRoutes;
